import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import Api from "../../../../../Services/Api";
import { getValueFromDDL, mapToObjectDDL } from "../../../../common/mapper";
import MutasiPartDetailInputs from "./mutasiPartDetailInputs";
import MutasiPartDetailTabs from "./mutasiPatDetailTabs";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import M from "moment";
import { printPDF } from "../../downloadUtils";
import moment from "moment";
import { fetchDataAsync } from "../../../../../Services/Utils";

class MutasiPartDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstLoad: true,
      alertVisible: false,
      loading: false,
      alertInformation: null,
      deleteAlertVisible: null,
      data: {
        muatationDate: M(new Date()).format("DD-MM-YYYY"),
        mutationSourceKodeLocator: null,
      },
      errorData: null,
      cabangOptions: [],
      locatorSourceOptions: [],
      locatorTargetOptions: [],
      kodeVarianOptions: [],
      kodeKSUOptions: [],
      kodeHadiahOptions: [],
      warnaOptions: [],
      partOptions: [],
      partBarcodeOptions: [],
      dataOfPrint: null,
      activityType: null,
      isRejectAllAction: false,
      anyByPassScanner: false,
      actionType: props.state.actionType,
    };
  }

  async componentDidMount() {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    let response;
    let muNo;
    if (this.props.state.id) {
      response = await this.props.tab.getById(this.props.state.id);
    } else {
      muNo = await Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave({
        seqType: "MutationH3",
        nosDealerCode: this.props.kodeCabang.value,
        transactionType: "MutationH3",
      });
    }

    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
      Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.kodeCabang.value },
      }),
      Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart({
        paramFilters: {},
      }),
    ]);

    if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        cabangOptions: responses[0].data.data.map((c) =>
          mapToObjectDDL(c.namaDealer, c.kodeCabang)
        ),
      }));
    }

    if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        locatorSourceOptions: responses[1].data.data.map((l) =>
          mapToObjectDDL(l.nameLocation, l.kodeLocation)
        ),
      }));
    }

    if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
      const allParts = responses[2].data.data;

      const partOptions = allParts
        .filter((p) => p.qrCode === false)
        .map((p) => ({
          label: p.kodePart,
          value: p.kodePart,
          name: p.partName,
          category: p.partCategory,
          satuan: p.satuan,
        }));

      const partBarcodeOptions = allParts
        .filter((p) => p.qrCode === true)
        .map((p) => ({
          label: p.kodePart,
          value: p.kodePart,
          name: p.partName,
          category: p.partCategory,
          satuan: p.satuan,
        }));

      this.setState((prevValue) => ({
        ...prevValue,
        partOptions,
        partBarcodeOptions,
      }));
    }

    if (response && !R.isEmpty(response.data.data)) {
      const data = response.data.data;

      const res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: data.mutationTargetKodeCabang.kodeCabang },
      });
      const res2 = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: data.mutationSourceKodeCabang.kodeCabang },
      });

      const locOptions2 = res2.data.data.map((l) =>
        mapToObjectDDL(l.nameLocation, l.kodeLocation)
      );
      const locOptions = res.data.data.map((l) =>
        mapToObjectDDL(l.nameLocation, l.kodeLocation)
      );

      this.setState((prevValue) => ({
        ...prevValue,
        activityType: ACTIVITY_TYPE.UPDATE,
        locatorTargetOptions: res.data.data.map((l) =>
          mapToObjectDDL(l.nameLocation, l.kodeLocation)
        ),
        dataOfPrint: response.data.data,
        data: {
          ...prevValue.data,
          ...data,
          mutationSourceKodeCabang: this.state.cabangOptions.find((c) =>
            R.equals(c.value, data.mutationSourceKodeCabang.kodeCabang)
          ),
          mutationTargetKodeCabang: this.state.cabangOptions.find((c) =>
            R.equals(c.value, data.mutationTargetKodeCabang.kodeCabang)
          ),
          mutationSourceKodeLocator: locOptions2.find((c) =>
            R.equals(c.value, data.mutationSourceKodeLocator)
          ),
          mutationTargetKodeLocator: data.mutationTargetKodeLocator
            ? locOptions.find((c) =>
                R.equals(c.value, data.mutationTargetKodeLocator)
              )
            : null,
          part: !R.isEmpty(data.part)
            ? data.part.map((mo) => {
                const partCode = this.state.partOptions.find((kbl) =>
                  R.equals(kbl.value, mo.partCode)
                );

                return {
                  ...mo,
                  satuan: partCode.satuan,
                  partCode: partCode ? { ...partCode } : null,
                  saved: true,
                  scanned: false,
                  status: data.status || null,
                };
              })
            : [],
          partBarcode: !R.isEmpty(data.partBarcode)
            ? data.partBarcode.map((mob) => {
                const partCode = this.state.partBarcodeOptions.find((kbl) =>
                  R.equals(kbl.value, mob.partCode)
                );

                return {
                  ...mob,
                  satuan: partCode.satuan,
                  partCode: partCode ? { ...partCode } : null,
                  qty: 1,
                  saved: true,
                  scanned: false,
                  checked: false,
                };
              })
            : [],
        },
      }));
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        activityType: ACTIVITY_TYPE.CREATE,
        data: {
          ...prevValue.data,
          mutationNumber: muNo.data,
          mutationSourceKodeCabang: this.state.cabangOptions.find((c) =>
            R.equals(c.value, this.props.kodeCabang.value)
          ),
          part: [],
          partBarcode: [],
        },
      }));
    }
    this.setState((prevValue) => ({ ...prevValue, loading: false }));
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevState.data.mutationTargetKodeCabang !==
      this.state.data.mutationTargetKodeCabang
    ) {
      if (!R.isNil(this.state.data.mutationTargetKodeCabang?.value)) {
        const res = await Api.create(
          "NAGAMAS_MASTER_DATA"
        ).getAllMasterLocationPagingByParam({
          paramFilters: {
            kodeCabang: this.state.data.mutationTargetKodeCabang.value,
          },
        });
        this.setState((prevValue) => ({
          ...prevValue,
          locatorTargetOptions: res.data.data.map((l) =>
            mapToObjectDDL(l.nameLocation, l.kodeLocation)
          ),
          data: {
            ...prevValue.data,
            mutationTargetKodeLocator: this.state.firstLoad
              ? this.state.data.mutationTargetKodeLocator
              : null,
          },
        }));
      }
    }
  }

  handleSubmit = async () => {
    this.saveDetail();
  };

  handleProcess = () => {
    const userId = localStorage.getItem("userId");
    console.log(userId, "userId");
    this.saveDetail("WAITING_APPROVAL", userId);
  };

  handleReset = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      alertTitle: "Warning",
      deleteAlertVisible: !prevValue.deleteAlertVisible,
    }));
  };

  handleSubmitDelete = async () => {
    const status = this.state.data.status;
    if (status === "PROCESSED") {
      return this.setState((prev) => ({
        ...prev,
        alertTitle: null,
        deleteAlertVisible: false,
        alertInformation: {
          error: true,
          content: (
            <p>
              Mutasi tidak dapat dihapus karna sudah dilakukan proses pada
              mutasi masuk.
              <br />
              Silahkan lakukan proses Mutasi keluar pada mutasi masuk.
            </p>
          ),
        },
      }));
    }

    this.setState({ loading: true });
    const res = await this.props.tab.delete(
      this.state.data.id,
      this.props.setError
    );

    this.setState({ loading: false });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleReset();
      this.props.onRefresh();
      this.props.onClickClose();
      this.setState((prevValue) => ({ ...prevValue, alertInformation: null }));
      return;
    }
    if (
      !res.data.data &&
      res.data?.message?.startsWith("Data cannot be deleted")
    ) {
      this.setState((prev) => ({
        ...prev,
        alertTitle: null,
        deleteAlertVisible: false,
        alertInformation: {
          error: true,
          content: <p>{res.data?.message}</p>,
        },
      }));
      return;
    }
  };

  handleStateChange = (callback) => {
    this.setState(callback);
  };

  handleAlertVisibility = () => {
    if (!this.state.alertInformation.error) {
      this.props.onClickClose();
    }
    this.setState((prevValue) => ({ ...prevValue, alertInformation: null }));
  };

  checkByPassScanBeforeProcess = () => {
    // if (!this.props.mutasiKeluarTab && this.anyUnchecked(this.state.data)) {
    //   this.setState((prevValue) => ({
    //     ...prevValue,
    //     loading: false,
    //     alertInformation: {
    //       error: true,
    //       content: (
    //         <div>
    //           <p>
    //             Ada field data yang perlu diisi atau tidak sesuai kriteria
    //             isian.
    //           </p>
    //           <br />
    //           <p>Mohon periksa kembali.</p>
    //         </div>
    //       ),
    //     },
    //   }));
    //   return true;
    // }

    if (
      !this.props.mutasiKeluarTab &&
      !this.state.anyByPassScanner &&
      this.anyByPassScanner(this.state.data)
    ) {
      this.setState((prevState) => ({
        ...prevState,
        loading: false,
        anyByPassScanner: true,
        alertTitle: "Proses Terima Mutasi",
        warningMessage:
          "Proses mutasi masuk bypass Scan QR. Apakah ingin meminta Approval?",
      }));
      this.handleAlertModalVisibility(false, true);
      return true;
    }

    return false;
  };

  anyUnchecked = (formValues) => {
    const anyUnCheckedOther = !R.isEmpty(formValues.partBarcode)
      ? formValues.partBarcode.some(
          (mob) => mob.checked === false && mob.status !== "REJECTED"
        )
      : false;

    return anyUnCheckedOther;
  };

  anyByPassScanner = (formValues) => {
    const anyByPassOther = !R.isEmpty(formValues.partBarcode)
      ? formValues.partBarcode.some(
          (mob) => mob.partBarcode === false && mob.status !== "REJECTED"
        )
      : false;

    return anyByPassOther;
  };

  validDetail = (formValues) => {
    if (this.props.mutasiKeluarTab) {
      return !R.isEmpty(formValues.part)
        ? !formValues.part.every(
            (mo) => (mo.partCode?.value || mo.qRCode) && mo.qty >= 1
          )
        : false;
    } else {
      return !R.isEmpty(formValues.part)
        ? !formValues.part.every(
            (mo) =>
              mo.receivedqty !== "" &&
              mo.receivedqty !== null &&
              mo.receivedqty !== undefined
          )
        : false;
    }
  };

  validateBeforeSave = (formValues) => {
    console.log(formValues);

    this.setState((prev) => ({ ...prev, errorData: {} }));

    if (!this.props.mutasiKeluarTab && !formValues.mutationTargetKodeLocator) {
      return {
        error: true,
        alert: {
          error: true,
          content: (
            <div>
              <p>
                Locator Penerima tidak ditemukan, harap pilih Locator Penerima.
              </p>
            </div>
          ),
        },
      };
    }

    if (!this.props.mutasiKeluarTab && !formValues.note) {
      return {
        error: true,
        alert: {
          error: true,
          content: (
            <div>
              <p>Catatan Penerima wajib diisi.</p>
            </div>
          ),
        },
      };
    }

    if (
      !formValues.mutationSourceKodeCabang ||
      !formValues.mutationTargetKodeCabang ||
      !formValues.mutationSourceKodeLocator ||
      this.validDetail(this.state.data)
    ) {
      return {
        error: true,
        alert: {
          error: true,
          content: (
            <div>
              <p>
                Ada field data yang perlu diisi atau tidak sesuai kriteria
                isian.
              </p>
              <br />
              <p>Mohon periksa kembali.</p>
            </div>
          ),
        },
      };
    }

    const noPart =
      (!this.state.data.part || this.state.data.part.length === 0) &&
      (!this.state.data.partBarcode ||
        this.state.data.partBarcode.length === 0);

    if (noPart) {
      return {
        error: true,
        alert: {
          error: true,
          content: (
            <div>
              <p>Part atau Part Barcode harus diisi</p>
              <br />
              <p>Tidak boleh kosong</p>
            </div>
          ),
        },
      };
    }

    const hasUnsavedPart =
      (this.state.data.part || []).some((p) => p.saved === false) ||
      (this.state.data.partBarcode || []).some((p) => p.saved === false);

    if (hasUnsavedPart) {
      return {
        error: true,
        alert: {
          error: true,
          content: (
            <div>
              <p>Ada data part yang belum disimpan.</p>
              <br />
              <p>Mohon periksa kembali.</p>
            </div>
          ),
        },
      };
    }
    return { error: false };
  };

  saveDetail = async (status = "ONPROGRESS", userId = null) => {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    const data = this.state.data;
    
    const formValues = {
      id: data.id || null,
      mutationId: data.mutationId || null,
      mutationNumber:
        this.state.activityType == ACTIVITY_TYPE.CREATE
          ? null
          : data.mutationNumber,
      muatationDate: data.muatationDate || "",
      mutationSourceKodeCabang: getValueFromDDL(
        data,
        "mutationSourceKodeCabang"
      ),
      mutationSourceKodeLocator: getValueFromDDL(
        data,
        "mutationSourceKodeLocator"
      ),
      mutationSourceKodeLocatorName:
        data.mutationSourceKodeLocator?.label || "",
      mutationTargetKodeCabang: getValueFromDDL(
        data,
        "mutationTargetKodeCabang"
      ),
      mutationTargetKodeLocator: getValueFromDDL(
        data,
        "mutationTargetKodeLocator"
      ),
      note: data.note,
      mutationTargetKodeName: data.mutationTargetKodeLocator?.label || "",
      mutationOutStatus: this.props.mutasiKeluarTab ? "WAITING_APPROVAL" : (data.mutationOutStatus || status),
      mutationInStatus: data.mutationInStatus || null,
      userId: userId || null,
      part: (data?.part || [])
        .filter((p) => p.saved !== false)
        .map((p) => ({
          id: p.id || null,
          mutationPartId: p.mutationPartId,
          mutationId: p.mutationId,
          partCode: p.partCode?.value || "",
          qty: p.qty,
          receivedqty: p.receivedqty != null ? p.receivedqty : 0,
          partName: p.partName || p.partCode?.name || "",
          partCategory: p.partCategory || p.partCode?.category || "",
          unitId: p.unitId || p.partCode?.satuan || "",
          unitName: p.unitName || p.partCode?.satuan || "",
          status: this.props.mutasiKeluarTab
            ? p.status || "ONPROGRESS"
            : Number(p.receivedqty) === 0
            ? "REJECTED"
            : p.status || "RECEIVED",
        })),
      partBarcode: (data?.partBarcode || [])
        .filter((p) => p.saved !== false)
        .map((p) => ({
          id: p.id || null,
          mutationPartId: p.mutationPartId,
          mutationId:
            p.mutationId && p.mutationId.trim() !== "" ? p.mutationId : null,
          partCode: p.partCode?.value || "",
          qRCode: p.qRCode || "",
          partCategoryName: p.partCategoryName || p.partCode?.category || "",
          partName: p.partName || p.partCode?.name || "",
          unitId: p.satuan || p.partCode?.satuan || "",
          unitName: p.satuan || p.partCode?.satuan || "",
          // receivedqty: p.receivedqty != null ? p.receivedqty : 0,
          scanned: p.scanned || false,
          status: this.props.mutasiKeluarTab
            ? p.status || "ONPROGRESS"
            : Number(p.receivedqty) === 0
            ? "REJECTED"
            : p.status || "RECEIVED",
        })),
    };
    if (this.props.mutasiKeluarTab) {
      formValues.mutationInStatus = null;
    }

    if (userId) {
      formValues.userId = userId;
    }

    const validation = this.validateBeforeSave(formValues);
    if (validation.error) {
      this.setState((prevValue) => ({
        ...prevValue,
        loading: false,
        alertInformation: validation.alert,
      }));
      return;
    }

    if (this.checkByPassScanBeforeProcess()) {
      return;
    }

    const renamedFormValues = Object.entries(formValues).reduce(
      (obj, [key, value]) => {
        let newKey = key;
        if (key === "mutationUnits") {
          newKey = "mutationUnit";
        } else if (key === "mutationKsus") {
          newKey = "mutationKsu";
        }
        obj[newKey] = value;
        return obj;
      },
      {}
    );

    let title;
    let alertMessage;
    let funcSubmit = "create";

    if (this.props.mutasiKeluarTab) {
      title =
        status === "ONPROGRESS" ? "Simpan Data Mutasi" : "Proses Data Mutasi";
      alertMessage =
        status === "ONPROGRESS"
          ? "Data mutasi barang keluar berhasil disimpan."
          : "Data mutasi barang keluar berhasil diproses untuk request Approval.";
      if (status === "WAITING_APPROVAL") {
        funcSubmit = "update";
      }
    } else {
      title = this.state.anyByPassScanner
        ? "Proses Terima Mutasi"
        : "Proses Data Mutasi";
      alertMessage = this.state.anyByPassScanner
        ? "Permintaan Approval telah dikirimkan. Mohon menunggu Approval."
        : "Data mutasi barang masuk berhasil diproses.";
    }

    console.log("Payload:", formValues);
    // console.log(this.props.tab);

    const response = await this.props.tab[funcSubmit](
      renamedFormValues,
      this.props.setError
    );

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        anyByPassScanner: false,
        alertInformation: {
          error: false,
          title: title,
          content: <p>{alertMessage}</p>,
        },
      }));
      this.props.onClickClose();
      this.props.onRefresh();
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        alertInformation: {
          error: true,
          content: response.data?.message || "Terjadi Kesalahan",
        },
      }));
    }

    this.setState({ loading: false });
  };

  additionalButton = () => {
    const status = this.state?.data?.status;
    if (this.props.mutasiKeluarTab) {
      if (this.props.state.buttonType === "delete") {
        return (
          <SimpleButton type="button" onClick={this.handleReset}>
            Hapus
          </SimpleButton>
        );
      } else if (this.props.state.buttonType === "preview") {
        return (
          <SimpleButton type="button" onClick={this.handlePrint}>
            Cetak
          </SimpleButton>
        );
      } else {
        return (
          <>
            <SimpleButton onClick={this.handleProcess}>Proses</SimpleButton>
            <SimpleButton onClick={this.handlePrint}>Cetak</SimpleButton>
          </>
        );
      }
    }

    if (!R.isNil(status) && status !== "WAITING_APPROVAL" && status !== "NEW") {
      return (
        <SimpleButton type="button" onClick={this.props.onClickClose}>
          Keluar
        </SimpleButton>
      );
    }

    if (this.props.state.buttonType !== "preview") {
      return (
        <>
          <SimpleButton onClick={this.handleProcess}>Proses</SimpleButton>
          <SimpleButton onClick={this.handleAlertRejectAll}>
            Reject All
          </SimpleButton>
        </>
      );
    }
  };

  handleAlertModalVisibility = (
    isRejectAllAction = false,
    anyByPassScanner = false
  ) => {
    this.setState((prevState) => ({
      ...prevState,
      isRejectAllAction: isRejectAllAction,
      anyByPassScanner: anyByPassScanner,
      alertVisible: !prevState.alertVisible,
    }));
  };

  handleAlertRejectAll = () => {
    if (!this.props.mutasiKeluarTab) {
      if (
        R.isNil(this.state.data.mutationTargetKodeLocator) ||
        R.isEmpty(this.state.data.mutationSourceKodeLocator)
      ) {
        this.setState((prevValue) => ({
          ...prevValue,
          loading: false,
          alertInformation: {
            error: true,
            content: (
              <div>
                <p>
                  Locator Penerima tidak ditemukan, harap pilih Locator
                  Penerima.
                </p>
              </div>
            ),
          },
        }));
        return;
      }
    }
    this.setState((prevState) => ({
      ...prevState,
      alertTitle: "Proses Mutasi Ditolak",
      warningMessage:
        "Data mutasi part masuk akan ditolak dan prosesnya tidak bisa dibatalkan. Apakah anda yakin?",
    }));
    this.handleAlertModalVisibility(true, false);
  };

  handlePrint = async () => {
    const { dataOfPrint, data } = this.state;
    const { cabangData } = this.props;
    const source = dataOfPrint || data;
    const userId = localStorage.getItem("userId");
    let resUser = await Api.create("NAGAMAS_MASTER_DATA").getUserProfile({
      idUser: userId,
    });
    let userProfile = resUser?.data?.data?.name ?? "-";
    const today = moment().format("DD-MM-YYYY HH:mm:ss");

    const getData = (valueFromPrint, valueFromDraft = "") =>
      dataOfPrint ? valueFromPrint : valueFromDraft;

    const listMutationPart = [
      ...(source.part || []),
      ...(source.partBarcode || []),
    ].map((p) => ({
      itemCode: p?.partCode?.value || p?.partCode || "",
      itemName: p?.partName || "",
      qty: p?.qty || p?.receivedqty || 1,
      unit: p?.unitName || p?.satuan || "PCS",
    }));
    console.log(source);

    const requestBody = {
      cabangName: getData(
        source?.mutationSourceKodeCabang?.namaDealer,
        this.props?.kodeCabang?.label
      ),
      address: getData(
        source?.mutationSourceKodeCabang?.alamat,
        source?.mutationSourceKodeCabang?.alamat || cabangData?.alamat || ""
      ),

      telepon: getData(
        source?.mutationSourceKodeCabang?.phoneShowroom,
        source?.mutationSourceKodeCabang?.phoneShowroom ||
          cabangData?.phoneShowroom ||
          ""
      ),
      fax: "",
      mtbNumber: source?.mutationNumber || "",
      mtbDate: source?.muatationDate || "",
      sourceCabang: getData(
        source?.mutationSourceKodeCabang?.namaDealer,
        source?.mutationSourceKodeCabang?.label
      ),
      sourceLocator: getData(
        source?.mutationSourceKodeLocatorName,
        source?.mutationSourceKodeLocator?.label
      ),
      targetCabang: getData(
        source?.mutationTargetKodeCabang?.namaDealer,
        source?.mutationTargetKodeCabang?.label
      ),
      targetLocator: getData(
        source?.mutationTargetKodeLocatorName,
        source?.mutationTargetKodeLocator?.label
      ),
      datePrint: today,
      userBy: userProfile,
      printOf: 1,
      listMutationPart,
    };

    console.log("REQUEST PRINT:", requestBody);

    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generatePrintMutationPart,
      setError: this.props.setError,
      menuName: "Mutasi Part",
      args: requestBody,
    });
    if (response.ok) {
      printPDF(response.data);
    }
    this.setState((prevValue) => ({
      ...prevValue,
      loading: false,
      alertVisible: false,
      cetak: true,
    }));
  };

  render() {
    return (
      <>
        <SimpleModal
          title={this.props.mutasiKeluarTab ? "Mutasi Keluar" : "Mutasi Masuk"}
          visible={this.props.state.detailVisible}
          onClickClose={this.props.onClickClose}
          content={
            <ModalContainer>
              <MutasiPartDetailInputs
                state={this.state}
                buttonType={this.props.state.buttonType}
                errorData={this.state.errorData}
                mutasiKeluarTab={this.props.mutasiKeluarTab}
                onSetState={this.handleStateChange}
              />
              <MutasiPartDetailTabs
                state={this.state}
                buttonType={this.props.state.buttonType}
                onSetState={this.handleStateChange}
                mutasiKeluarTab={this.props.mutasiKeluarTab}
              />
              <FlexView
                vAlignContent="center"
                hAlignContent="right"
                className="margin-top-15px"
              >
                {this.additionalButton()}
              </FlexView>
            </ModalContainer>
          }
        />
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.alertInformation !== null && (
          <SimpleAlert
            visible={this.state.alertInformation !== null}
            title={this.state.alertInformation.title || "Information"}
            onClickClose={this.handleAlertVisibility}
            content={
              <div>
                {this.state.alertInformation.content}
                <SimpleButton
                  className="margin-left-none margin-top-15px"
                  onClick={this.handleAlertVisibility}
                >
                  OK
                </SimpleButton>
              </div>
            }
          />
        )}
        {this.state.deleteAlertVisible && (
          <SimpleAlert
            visible={this.state.deleteAlertVisible}
            title={this.state.alertTitle || "Information"}
            onClickClose={this.handleReset}
            content={
              <div>
                <p>Anda yakin hendak menghapus baris data ini ?</p>
                <FlexView hAlignContent="center">
                  <SimpleButton
                    className="margin-left-none margin-top-15px"
                    onClick={this.handleSubmitDelete}
                  >
                    Ya
                  </SimpleButton>
                  <SimpleButton
                    className="margin-top-15px"
                    onClick={this.handleReset}
                  >
                    Batal
                  </SimpleButton>
                </FlexView>
              </div>
            }
          />
        )}
        {this.state.alertVisible && (
          <SimpleAlert
            title={this.state.alertTitle || "Information"}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            visible={this.state.alertVisible}
            onClickClose={this.handleAlertModalVisibility}
            additionalButtons={
              this.state.isRejectAllAction ? (
                <FlexView hAlignContent={"right"} vAlignContent={"center"}>
                  <SimpleButton
                    secondary
                    type="button"
                    text="Batal"
                    onClick={() => this.handleAlertModalVisibility()}
                  />
                  <SimpleButton
                    type="button"
                    text="Reject"
                    onClick={() => this.props.handleRejectAll(this.state.data)}
                  />
                </FlexView>
              ) : this.state.anyByPassScanner ? (
                <FlexView hAlignContent={"right"} vAlignContent={"center"}>
                  <SimpleButton
                    secondary
                    type="button"
                    text="Batal"
                    onClick={() => this.handleAlertModalVisibility()}
                  />
                  <SimpleButton
                    type="button"
                    text="Ya"
                    onClick={() => {
                      this.setState((prevValue) => ({
                        ...prevValue,
                        alertVisible: !prevValue.alertVisible,
                      }));
                      this.handleProcess();
                    }}
                  />
                </FlexView>
              ) : (
                <>
                  <SimpleButton
                    type="button"
                    text="OK"
                    onClick={() => this.handleAlertModalVisibility()}
                  />
                </>
              )
            }
          />
        )}
      </>
    );
  }
}

export default MutasiPartDetail;
